module.exports = __webpack_public_path__ + "img/vision-2.0b5631a8.svg";